import React from 'react';
import '../Style/Services.css';

    const ServicesSection = ({ percentage, imageSrc, text }) => {
      return (
        <>
        <div className="mindseed-item">
          <div className="img">
            <img className="img-fluid w-100" src={imageSrc} alt="mindseed" />
          </div>
          <div className="inner">
            <div className="percentage">
            </div>
            <div className='services-text'>{text}</div>
          </div>
        </div>
        </>
      );
    };
    


export default ServicesSection;